
const LoadingModule = () => {
  return (
    <div className="courseModule loadingModule">
      <div className="courseModuleContent">
        <div className="moduleNumber"></div>
        <div className="loadingBlock"></div>
        <div className="loadingDescription"></div>
      </div>
    
    </div>
  );
};

export default LoadingModule;
